import styled from 'styled-components';

const EBarResourcesResultDiv = styled.div`
  width: 100%;
`;

EBarResourcesResultDiv.displayName = 'EBarResourcesResultDiv';

export default EBarResourcesResultDiv;
